import InternalConfigs from './InternalConfigs';

export default InternalConfigs;
